// extracted by css-extract-rspack-plugin
export default {"value":"VjL6z","increase":"jeKad","decrease":"DQWLp"};